<template>
  <div class="element-content-checkbox">
    <div class="label">{{ label }}</div>
    <ul>
      <li
        v-if="(!!usage && !!item.useage) || !usage"
        :class="on(item)"
        :key="index"
        v-for="(item, index) in items"
        @click="clickOptions(index, item.label)"
      >
        <div class="container">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-sublabel">{{ item.subLabel }}</div>
        </div>
        <div class="function"><i class="fa fa-angle-right"></i></div>
      </li>
    </ul>
    <div class="error" v-if="error !== ''">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "index", "requirement", "usage" ],
  data() {
    return {
      status: {
        popup: false,
        index: '',
        option: -1,
        label: '',
      },
    }
  },
  computed: {
    isMultiple(){
      return this.items && this.items.length > 1;
    },
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    },
    on() {
      return (item) => {
        let className = '';

        if (this.requirement || (this.isMultiple ? ( this.value.findIndex(o => o.label === item.value) >= 0 ) : this.value)) {
          className = 'on';
        }

        if (this.label === '추천 특약' && item.subLabel === '미가입') {
          className = '';
        }

        return className;
      }
    }
  },
  created(){
    this.$watch( "isMultiple", isMultiple => {
      
      if( isMultiple && !Array.isArray( this.value ) ){
        this.$emit( "input", []);
      };
    }, { immediate: true });
  },
  methods: {
    clickOptions(index, label){
      if(this.status.index != index && this.status.popup){
        this.status.popup = true;
      } else {
        this.status.popup = !this.status.popup;
      }

      this.status.option = this.index;
      this.status.label = label;
      this.status.index = index;
      this.$emit( "status", this.status ); 
    },
    selectItem( value ){
      if( this.isMultiple ){
        if( this.value.indexOf( value ) >= 0 ){
          this.$emit( "input", this.value.filter( o => o != value ) );
        }else{
          
          this.$emit( "input", this.value.concat( [ value ] ) );
        };
      }else{
        if( this.value ){
          this.$emit( "input", false );
        }else{
          this.$emit( "input", true );
        };
      };
    }
  }
}
</script>
<style scoped>
.error {
  margin-top: 0.5rem;
  color: #cc3232;
}
</style>